import React from 'react'

export default class MatrixValue extends React.Component {

  render() {

    // NB: a NULL score is also valid and should be handled differently than 0
    const {score} = this.props

    // Render labels, which are Strings
    if (score !== null && typeof score === 'string') {
      return (<span>{score}</span>)
    }

    // values from BW-137
    const medium = 5
    const large  = 10

    let className = 'score'

    if (score !== null) {
      className += (score >= 0 ? ' positive' : ' negative')
    }

    if (score !== null) {
      const absScore = Math.abs(score)
      let size = ''

      if (absScore > large) {
        size = ' large'
      } else if (absScore > medium) {
        size = ' medium'
      } else {
        size = ' small'
      }

      className = className + size 
    } else {
      className = className + ' none'
    }

    return (
      <span className={className}>{score && score/10}</span>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/MatrixValue.js